import { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import urls from "../urls";
import formatDateDZ from "../utils/formatDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesLeft,
  faCheck,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import OrderDetails from "./orderDetails";
import { showError, showSuccess } from "../utils/notifications";
import _ from "lodash";
import DeliveryStatus from "../shared-components/delivery-status";
import DeliveryStatusModal from "../shared-components/delivery-status/delivery-status-modal";
import {
  setOBJ,
  showObjModal,
  SetOrderStatus,
} from "../redux-state/features/orderState";
class UserApplictionDetails extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      applicationdetails: [],
    };
    this.status = {
      pending: "قيد المعالجة",
      approved: "تمّ قبول الطلب",
      rejected: "تمّ رفض الطلب",
      served: "تمّ إستلام الطلب",
      confirmed: "تمّ تسليم الطلب في إنتظار تأكيد المستخدم",
    };
  }

  componentDidMount() {
    const { uuid, faculty_id } = this.props;

    axios
      .get(urls.getOrders(uuid), {
        params: {
          faculty_id,
        },
      })
      .then((res) => {
        this.setState({
          applicationdetails: res.data.map((obj) => ({
            ...obj,
            order_details:
              typeof obj.order_details === "string"
                ? JSON.parse(obj.order_details)
                : obj.order_details,
          })),
        });
      })
      .catch((err) => console.log(err));
  }
  deleteOrder = (orderId) => {
    const { applicationdetails } = this.state;

    axios
      .delete(urls.deleteOrder(orderId))
      .then((res) => {
        const state = _.filter(
          applicationdetails,
          (obj) => obj.order_id != orderId
        );
        this.setState({ applicationdetails: state });
        showSuccess("تم حذف الطلب بنجاح ");
      })
      .catch((err) => {
        console.log(err);
        showError("لم  يتم حذف الطلب بنجاح ");
      });
  };
  confirmServed = (orderId) => {
    axios
      .put(urls.confirmOrder, {
        data: { orderId, orderStatus: "served" },
      })
      .then((res) => {
        showSuccess("تم تأكيد الأستلام");
      })
      .catch((err) => {
        showError("لم يتم تأكيد الاستلام ");
      });
  };
  render() {
    const { applicationdetails } = this.state;
    const status = this.status;
    const textColor = {
      pending: "text-warning",
      approved: "text-info",
      confirmed: "text-success",
      served: "text-success",
      rejected: "text-danger",
    };
    const bgColor = {
      pending: "rgba(244, 255, 94, 0.23)",
      approved: "rgba(104, 212, 255, 0.1)",
      confirmed: "rgba(66, 253, 82, 0.21)",
      served: "rgba(66, 253, 82, 0.12)",
      rejected: "rgba(253, 66, 66, 0.12)",
    };
    return (
      <>
        <div className="container-fluid  mt-3">
          <h6>تفاصيل الطلبات المقدمة </h6>
          <hr />

          {applicationdetails.map((obj, idx) => (
            <div
              className="border border-1 mb-1 pt-2 row"
              style={{
                backgroundColor: bgColor[obj.order_status],
                color: "black",
              }}
            >
              <div className="col">
                <p>
                  <span className="h6">{idx + 1} - </span>
                  تاريخ الطلب <br />{" "}
                  <span className="text-muted">
                    {formatDateDZ(obj.order_date)}
                  </span>
                </p>
              </div>
              <div className="col">
                <span className="text-center">
                  {" "}
                  حالة الطلب
                  <br />
                  <strong className={textColor[obj.order_status]}>
                    {status[obj.order_status]}
                  </strong>
                </span>
              </div>
              <div className="col">
                {" "}
                {!["served", "pending", "rejected"].includes(
                  obj.order_status
                ) && (
                  <button
                    className="btn  text-success"
                    onClick={() => this.confirmServed(obj.order_id)}
                    title="تأكيد إستلام الطلب"
                  >
                    <FontAwesomeIcon icon={faCheck} size="xl" />
                  </button>
                )}
                {obj.order_status != "served" && (
                  <button
                    className="btn  text-danger"
                    onClick={() => this.deleteOrder(obj.order_id)}
                    title="حذف الطلب "
                  >
                    <FontAwesomeIcon icon={faTrashCan} size="xl" />
                  </button>
                )}
              </div>
              <div className="col text-center">
                <button
                  className="btn border border-1"
                  type="button"
                  // data-bs-toggle="collapse"
                  // data-bs-target={`#${obj.order_date}`}
                  // aria-expanded="false"
                  // aria-controls={`${obj.order_date}`}
                  onClick={() => {
                    this.props.setOBJ(obj.order_details);
                    this.props.SetOrderStatus(obj.order_status);
                    this.props.showObjModal();
                  }}
                >
                  عرض تفاصيل الطلب
                  <FontAwesomeIcon icon={faAnglesLeft} className="mx-3" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = { showObjModal, setOBJ, SetOrderStatus };
const mapStateToProps = (state) => ({
  uuid: state.userState.uuid,
  faculty_id: state.userState.faculty_id,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserApplictionDetails);
